export default __webpack_public_path__ + "static/media/Resume_Debasree_Bhowmik.6f91ab7a.pdf";